var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blockData.imageList.image_url.length > 0)?_c('div',{ref:"imgSlide",staticClass:"course-whiteboard-slide w-100 d-flex justify-content-center align-items-center image_block",class:{
        'h-100': _vm.isWhiteboard,
    }},[_c('b-img',{ref:"img",attrs:{"src":_vm.blockData.imageList.image_url,"alt":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }